<template>
    <div v-cloak>
        <div class="simple-row">
            <div class="left">
                <template v-if="showMerchtSelect">
                    <swb-mercht-select-popover :merchantType="'retailer'" :defSelectId="merchantId" :selectHandler="selectMerchtHandler"></swb-mercht-select-popover>
                </template>
            </div>
        </div>
        <div class="search-layout" :class="{'pop-mini' : searchSize == 'mini'}" v-if="enableSearch != null && enableSearch == true">
            <swb-query-sort-area ref="query_model_ctrl" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler" :onConfigReady="onQueryConfigReady"></swb-query-sort-area>
        </div>
        <div class="org-tree">
            <el-radio-group v-if="isRadio" v-model="checkComId" style="display: block;height: calc(100% - 52px - 28px)">
                <el-tree class="filter-tree" :accordion="accordion" :load="loadNode" lazy="" :node-key="'nodeKey'" :data="comList" :highlight-current="highlightCurrent" :props="defaultProps" @node-click="clickNode"
                         :filter-node-method="filterNode" ref="comTree" :render-content="renderContent" @node-expand="nodeExpand" @node-collapse="nodeCollapse" :default-expanded-keys="openNodeKeys"></el-tree>
            </el-radio-group>
            <div v-else style="height: calc(100% - 52px - 28px)">
                <el-tree class="filter-tree" :accordion="accordion" :load="loadNode" lazy="" :node-key="'nodeKey'" :data="comList" :highlight-current="highlightCurrent" :props="defaultProps" @node-click="clickNode"
                         :filter-node-method="filterNode" ref="comTree" :render-content="renderContent" @node-expand="nodeExpand" @node-collapse="nodeCollapse" :default-expanded-keys="openNodeKeys"></el-tree>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, filterByName, Routes} from '../../app.vues'

    import userApi from '../../api/user'
    import retailerApi from '../../api/retailer'
    import {isSysRescFrozenIsAllowed} from '../index'
    import {loadgetRetailerBizFormList, loadRetailerMgmtAreaTree, loadRetailerShopTagList} from '../retailer/asset-comn';
    import {openComDetailDlg} from '../orgStruct/selectDlg'

    import SwbMerchtSelectPopover from '../merchant/MerchtSelectPopover';

    Vue.regist(SwbMerchtSelectPopover);

    import SwbOrgTreeSortSet from '../orgStruct/orgTreeSortSet'

    Vue.regist(SwbOrgTreeSortSet);

    let mockConfigData = {
        'queryFields': [
            {
                'code': 'name',
                'label': '机构名称',
                'type': 'Text',
                'valueType': 'String',
                'basic': true,
                'hidden': false,
                'rptUsed': false,
                'useLikeMatch': true,
                'ctxBindName': null
            },
            {
                'code': 'states',
                'label': '状态',
                'type': 'Select',
                'valueType': 'Integer',
                'value': null,
                'basic': true,
                'hidden': false,
                'rptUsed': false,
                'ctxBindName': null,
                'dataList': [],
                'multiple': true,
                'firstOnClear': true,
                'firstIsMutex': false,
                'multipleLimit': 0,
                'collapseTags': true
            },
            {
                'code': 'orgTypes',
                'label': '机构类型',
                'type': 'Casc',
                'valueType': 'Integer',
                'value': null,
                'basic': true,
                'hidden': false,
                'rptUsed': false,
                'ctxBindName': null,
                'dataList': [{
                    value: -1,
                    label: '业务单元',
                    children: [{
                        value: 2,
                        label: '仅门店',
                        leaf: true
                    }, {
                        value: 3,
                        label: '非门店',
                        leaf: true
                    }]
                }, {
                    value: 0,
                    label: '部门',
                    leaf: true
                }],
                'multiple': true
            },
            {
                'code': 'bizFormIds',
                'label': '经营业态',
                'type': 'Select',
                'valueType': 'Integer',
                'value': null,
                'basic': false,
                'hidden': false,
                'rptUsed': false,
                'ctxBindName': null,
                'dataList': [],
                'multiple': true
            },
            {
                'code': 'tagIds',
                'label': '标签',
                'type': 'Select',
                'valueType': 'String',
                'value': null,
                'basic': false,
                'hidden': false,
                'rptUsed': false,
                'ctxBindName': null,
                'dataList': [],
                'multiple': true
            },
            {
                'code': 'mgmtSmlAreaIds',
                'label': '管理区域',
                'type': 'Casc',
                'valueType': 'Integer',
                'basic': false,
                'hidden': false,
                'rptUsed': false,
                'ctxBindName': null,
                'multiple': true,
                'dataList': []
            },
            {
                'code': 'fiscalSubjectCode',
                'label': '财务主体代码',
                'type': 'Text',
                'valueType': 'String',
                'basic': false,
                'hidden': false,
                'rptUsed': false,
                'useLikeMatch': true,
                'ctxBindName': null
            }
        ],
        'sortFields': [
            {
                'code': 'createTime',
                'label': '创建时间',
                'order': 'desc',
                'enabled': false
            },
            {
                'code': 'name',
                'label': '名称',
                'order': 'desc',
                'enabled': false
            },
            {
                'code': 'no',
                'label': '机构编号',
                'order': 'desc',
                'enabled': false
            },
            {
                'code': 'openedTime',
                'label': '实际开业时间',
                'order': 'desc',
                'enabled': false
            },
            {
                'code': 'closedTime',
                'label': '实际闭店时间',
                'order': 'desc',
                'enabled': false
            }
        ]
    };

    export default {
        name: 'swb-retail-org-tree',
        desc: '组织架构树组件',
        props: {
            enableSearch: {
                type: Boolean,
                default: true
            },
            isRadio: {
                type: Boolean,
                default: false
            },
            isCom: {    // 是否获取全部的公司
                type: Boolean,
                default: false
            },
            accordion: {    // 是否手风琴模式
                type: Boolean,
                default: false
            },
            isSelectThisLevel: { //本级是否可选
                type: Boolean,
                default: false
            },
            dblclickFlag: { // 是否双击事件
                type: Boolean,
                default: false
            },
            optionalState: { // 可选的state
                type: Array,
                default: function () {
                    return [1, 3, 4];
                }
            },
            defalultState: { // 默认选中的state
                type: Array,
                default: function () {
                    return [1, 3]
                }
            },
            showMerchtSelect: {
                type: Boolean,
                default: false
            },
            closedComSelect: {
                type: Boolean,
                default: false
            },
            bizDepart: {
                type: Boolean,
                default: false
            },
            merchantId: {
                type: Number,
                default: null
            },
            bizUnitId: {
                type: Number,
                default: null
            }
        },
        watch: {},
        data: function () {
            return {
                highlightCurrent: true,
                comList: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                checkComId: null,
                checkComItem: {},
                thisComId: null,
                treeCollapse: true,
                includeClosed: false,
                openNodeKeys: [],
                lastSelectedNodeId: null, // 最后一次触发节点Id
                lastSelectTime: null, // 最后一次触发时间
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {
                        states: [1, 3]
                    },
                    sortItemList: [],
                    sortItems: {}
                }
            }
        },
        created: function () {
            this.queryConfig = Utils.merge({}, mockConfigData);
            this.queryModel.filterItems.states = Utils.merge([], this.defalultState);
            //
            this.getCurrentUserInfo();
        },
        methods: {
            onQueryConfigReady: function (event) {
                let self = this;
                // 业态
                loadgetRetailerBizFormList(function (dataList) {
                    self.updateQueryModelField('bizFormIds', dataList);
                });
                // 门店标签
                loadRetailerShopTagList(function (dataList) {
                    self.updateQueryModelField('tagIds', dataList);
                }, true);
                // 管理区域
                loadRetailerMgmtAreaTree(this.retailerId, function (dataList) {
                    self.updateQueryModelField('mgmtSmlAreaIds', dataList);
                });
                // 机构状态
                let dataList = [];
                let dataValue = [];
                let stateMap = {
                    0: '筹备中',
                    1: '营业中',
                    3: '计划停业',
                    4: '已停业'
                };
                let optionalState = this.optionalState;
                let defalultState = this.defalultState;
                optionalState.forEach(function (state) {
                    dataList.push({
                        'label': stateMap[state],
                        'value': state
                    });
                    if (defalultState.indexOf(state) > -1) {
                        dataValue.push(state);
                    }
                });
                self.updateQueryModelField('states', dataList, dataValue);
            },
            updateQueryModelField: function (itemCode, dataList = [], dataValue) {
                let self = this;
                if (itemCode != null) {
                    setTimeout(function () {
                        let query_model_ctrl = self.$refs['query_model_ctrl'];
                        let data = {
                            dataList: dataList
                        };
                        if (!Utils.isNoB(dataValue)) {
                            data.value = dataValue;
                        }
                        let fieldInfo = {};
                        fieldInfo[itemCode] = data;
                        query_model_ctrl.updateFields(fieldInfo);
                    }, 500);
                }
            },
            selectMerchtHandler: function (mercht) {
                this.merchantId = mercht.id;
                this.thisComId = mercht.comId;
                this.queryHandler(this.queryModel);
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                if (this.bizDepart) {
                    this.handleFilterTextClickOrg(queryModel);
                } else {
                    this.handleFilterTextClickBizUnit(queryModel);
                }
            },
            handleFilterTextClickOrg: function (queryModel) {
                // 含部门机构树过滤
                let self = this;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                if ((Utils.isNoB(filterItems.name) || filterItems.name.length == 0) && //
                    (Utils.isNoB(filterItems.states) || filterItems.states.length == 0) && //
                    (Utils.isNoB(filterItems.orgTypes) || filterItems.orgTypes.length == 0) && //
                    (Utils.isNoB(filterItems.bizFormIds) || filterItems.bizFormIds.length == 0) && //
                    (Utils.isNoB(filterItems.tagIds) || filterItems.tagIds.length == 0) && //
                    (Utils.isNoB(filterItems.mgmtSmlAreaIds) || filterItems.mgmtSmlAreaIds.length == 0) && //
                    (Utils.isNoB(filterItems.fiscalSubjectCode) || filterItems.fiscalSubjectCode.length == 0)
                ) {
                    filterItems.lazyFlag = true;
                } else {
                    filterItems.lazyFlag = false;
                }
                // orgTypes
                if (!Utils.isNoB(filterItems.orgTypes) && filterItems.orgTypes.length > 0) {
                    let orgTypes = filterItems.orgTypes;
                    if (orgTypes.indexOf(2) > -1 || orgTypes.indexOf(3) > -1) {
                        orgTypes.push(1);
                        if (orgTypes.indexOf(2) == -1) {
                            filterItems.shopFlag = false;
                        }
                        if (orgTypes.indexOf(3) == -1) {
                            filterItems.shopFlag = true;
                        }
                    }
                }
                filterItems.isCom = this.isCom;
                filterItems.merchantId = this.merchantId;
                filterItems.bizUnitId = this.bizUnitId || null;
                let theLoad = MsgBox.loading();
                let sortedFilter = {
                    filterItems: filterItems,
                    sortItemList: Utils.merge([], queryModel.sortItemList),
                    sortItems: Utils.merge({}, queryModel.sortItems)
                }
                retailerApi.getRetailerComList(sortedFilter, function (result, jqXhr) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let data = result.data;
                        //
                        //对树节点数据进行过滤处理（设置 nodeKey）
                        self.normalizeTreeNode(data);
                        //
                        let comList = Utils.merge([], data);
                        //
                        let nodeKey = [];
                        let comIds = result.codeName || null;
                        if (!Utils.isNoB(comIds)) {
                            nodeKey = JSON.decode(comIds) || [];
                        }
                        self.comList = comList;
                        self.openNodeKeys = Utils.merge([], nodeKey);
                    } else {
                        self.comList = [];
                        self.$message.error(result.message);
                    }
                });
            },
            handleFilterTextClickBizUnit: function (queryModel) {
                // 不含部门机构树过滤
                let self = this;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                if ((Utils.isNoB(filterItems.name) || filterItems.name.length == 0) && //
                    (Utils.isNoB(filterItems.states) || filterItems.states.length == 0) && //
                    (Utils.isNoB(filterItems.orgTypes) || filterItems.orgTypes.length == 0) && //
                    (Utils.isNoB(filterItems.bizFormIds) || filterItems.bizFormIds.length == 0) && //
                    (Utils.isNoB(filterItems.tagIds) || filterItems.tagIds.length == 0) && //
                    (Utils.isNoB(filterItems.mgmtSmlAreaIds) || filterItems.mgmtSmlAreaIds.length == 0) && //
                    (Utils.isNoB(filterItems.fiscalSubjectCode) || filterItems.fiscalSubjectCode.length == 0)
                ) {
                    filterItems.lazyFlag = true;
                } else {
                    filterItems.lazyFlag = false;
                }
                // orgTypes
                if (!Utils.isNoB(filterItems.orgTypes) && filterItems.orgTypes.length > 0) {
                    let orgTypes = filterItems.orgTypes;
                    if (orgTypes.indexOf(2) > -1 || orgTypes.indexOf(3) > -1) {
                        orgTypes.push(1);
                        if (orgTypes.indexOf(2) == -1) {
                            filterItems.shopFlag = false;
                        }
                        if (orgTypes.indexOf(3) == -1) {
                            filterItems.shopFlag = true;
                        }
                    }
                }
                filterItems.isCom = this.isCom;
                filterItems.merchantId = this.merchantId;
                let theLoad = MsgBox.loading();
                let sortedFilter = {
                    filterItems: filterItems,
                    sortItemList: Utils.merge([], queryModel.sortItemList),
                    sortItems: Utils.merge({}, queryModel.sortItems)
                }
                retailerApi.getRetailerComBizUnitList(sortedFilter, function (result, jqXhr) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let data = result.data;
                        //
                        //对树节点数据进行过滤处理（设置 nodeKey）
                        self.normalizeTreeNode(data);
                        //
                        let comList = Utils.merge([], data);
                        //
                        let nodeKey = [];
                        let comIds = result.codeName || null;
                        if (!Utils.isNoB(comIds)) {
                            nodeKey = JSON.decode(comIds) || [];
                        }
                        self.comList = comList;
                        self.openNodeKeys = Utils.merge([], nodeKey);
                    } else {
                        self.comList = [];
                        self.$message.error(result.message);
                    }
                });
            },
            handleCheckedChange: function () {
                this.getLazyComList();
            },
            nodeExpand(data, node, vueComponent) {
                this.openNodeKeys.push(data.nodeKey);
            },
            nodeCollapse(data, node, vueComponent) {
                this.openNodeKeys.remove(data.nodeKey);
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        self.thisComId = data.scopeEntity.comId;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            loadNodeOrg(node, resolve) {
                let self = this;
                let dbChildren = node.data.children || [];
                if (dbChildren != null && dbChildren.length > 0) {
                    return resolve(dbChildren);
                }
                //
                if (node.level === 0) {
                    this.getLazyComList();
                } else {
                    if (node.level >= 10) {
                        return resolve(dbChildren);
                    }
                    let parentId = node.data.id;
                    let postData = {};
                    postData.lazyFlag = true;
                    postData.parentId = parentId;
                    postData.isCom = this.isCom;
                    postData.merchantId = self.merchantId;
                    postData.bizUnitId = this.bizUnitId || null;
                    //
                    let queryModel = this.queryModel;
                    let filterItems = Utils.merge({}, queryModel.filterItems);
                    if (!Utils.isNoB(filterItems.states) && filterItems.states.length > 0) {
                        postData.states = filterItems.states;
                    }
                    let sortedFilter = {
                        filterItems: postData,
                        sortItemList: Utils.merge([], queryModel.sortItemList),
                        sortItems: Utils.merge({}, queryModel.sortItems)
                    }
                    retailerApi.getRetailerComList(sortedFilter, function (result) {
                        if (result.type == 'info') {
                            let data = result.data;
                            self.normalizeTreeNode(data);
                            let children = data;
                            if (dbChildren != null) {
                                children = dbChildren.concat(data);
                            }
                            resolve(children);
                        } else {
                            resolve([]);
                            self.$message.warning(result.message);
                        }
                    });
                }
            },
            loadNodeBizUnit(node, resolve) {
                let self = this;
                let dbChildren = node.data.children || [];
                if (dbChildren != null && dbChildren.length > 0) {
                    return resolve(dbChildren);
                }
                //
                if (node.level === 0) {
                    this.getLazyComList();
                } else {
                    if (node.level >= 10) {
                        return resolve(dbChildren);
                    }
                    let parentBizUnitId = node.data.bizUnitId;
                    let postData = {};
                    postData.lazyFlag = true;
                    postData.parentBizUnitId = parentBizUnitId;
                    postData.isCom = this.isCom;
                    postData.merchantId = this.merchantId;
                    //
                    let queryModel = this.queryModel;
                    let filterItems = Utils.merge({}, queryModel.filterItems);
                    if (!Utils.isNoB(filterItems.states) && filterItems.states.length > 0) {
                        postData.states = filterItems.states;
                    }
                    let sortedFilter = {
                        filterItems: postData,
                        sortItemList: Utils.merge([], queryModel.sortItemList),
                        sortItems: Utils.merge({}, queryModel.sortItems)
                    }
                    retailerApi.getRetailerComBizUnitList(sortedFilter, function (result) {
                        if (result.type == 'info') {
                            let data = result.data;
                            self.normalizeTreeNode(data);
                            let children = data;
                            if (dbChildren != null) {
                                children = dbChildren.concat(data);
                            }
                            resolve(children);
                        } else {
                            resolve([]);
                            self.$message.warning(result.message);
                        }
                    });
                }
            },
            loadNode(node, resolve) {
                if (this.bizDepart) {
                    this.loadNodeOrg(node, resolve);
                } else {
                    this.loadNodeBizUnit(node, resolve);
                }
            },
            getLazyOrgComList: function (parentId) {
                let self = this;
                let postData = {};
                postData.lazyFlag = true;
                postData.parentId = parentId || null;
                postData.isCom = this.isCom;
                postData.merchantId = self.merchantId;
                postData.bizUnitId = this.bizUnitId || null;
                //
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                if (!Utils.isNoB(filterItems.states) && filterItems.states.length > 0) {
                    postData.states = filterItems.states;
                }
                let sortedFilter = {
                    filterItems: postData,
                    sortItemList: Utils.merge([], queryModel.sortItemList),
                    sortItems: Utils.merge({}, queryModel.sortItems)
                }
                retailerApi.getRetailerComList(sortedFilter, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        //
                        //对树节点数据进行过滤处理（设置 nodeKey）
                        self.normalizeTreeNode(data);
                        //
                        self.comList = data;
                        self.initLazyComList = data;
                        //
                        if (data != null && data.length > 0) {
                            let item = data[0];
                            self.notityInitChange(item);
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                })
            },
            getLazyBizUnitComList: function (parentId) {
                let self = this;
                let postData = {};
                postData.lazyFlag = true;
                postData.parentBizUnitId = parentId || null;
                postData.isCom = this.isCom;
                postData.merchantId = self.merchantId;
                //
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                if (!Utils.isNoB(filterItems.states) && filterItems.states.length > 0) {
                    postData.states = filterItems.states;
                }
                let sortedFilter = {
                    filterItems: postData,
                    sortItemList: Utils.merge([], queryModel.sortItemList),
                    sortItems: Utils.merge({}, queryModel.sortItems)
                }
                retailerApi.getRetailerComBizUnitList(sortedFilter, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        //
                        //对树节点数据进行过滤处理（设置 nodeKey）
                        self.normalizeTreeNode(data);
                        //
                        self.comList = data;
                        self.initLazyComList = data;
                        //
                        if (data != null && data.length > 0) {
                            let item = data[0];
                            self.notityInitChange(item);
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                })
            },
            getLazyComList: function (parentId) {
                if (this.bizDepart) {
                    this.getLazyOrgComList(parentId);
                } else {
                    this.getLazyBizUnitComList(parentId);
                }
            },
            filterNode: function (value, data) {
                if (!value) {
                    return true;
                }
                return data.name.indexOf(value) !== -1;
            },
            renderContent: function (createElement, node) {
                let leafFlag = node.data.leafFlag;
                if (leafFlag) {
                    let children = node.data.children || [];
                    if (children == null || children.length <= 0) {
                        leafFlag = true;
                    } else {
                        leafFlag = false;
                    }
                }
                node.node.isLeaf = leafFlag;
                let selfTree = this;
                let isAllowed = isSysRescFrozenIsAllowed(selfTree, node.data);
                node.data.isAllowed = isAllowed;
                return createElement({
                    data: function () {
                        return {
                            item: node,
                            isAllowed: isAllowed,
                            checkComId: selfTree.checkComId,
                            thisComId: selfTree.thisComId,
                            isRadio: selfTree.isRadio,
                            isSelectThisLevel: selfTree.isSelectThisLevel
                        };
                    },
                    template: '<span style="display: inline-block; width: calc(100% - 25px);">' +
                        '<span class="inline-block ellipsis pr10" style="width: 100%;margin-top:3px;" v-if = "isRadio == false || (!isSelectThisLevel && thisComId == item.data.id)">' +
                        '<i v-if = "item.data.shopFlag" class="icon iconfont icon-mendian1 mr5 font-blue"></i>' +
                        '<i v-if = "item.data.orgType == 0" class="icon iconfont icon-icon-folder mr5 font-gray"></i>' +
                        '<i v-if = "item.data.orgType == 1 && item.data.shopFlag == false" class="icon iconfont icon-gongsi1 mr5 font-blue"></i>' +
                        '<span>{{item.data.name}}</span>' +
                        '<el-tag type="danger" v-if="item.data.state == 0">筹备中</el-tag>' +
                        '<el-tag type="danger" v-if="item.data.state == 3">计划停业</el-tag>' +
                        '<el-tag type="danger" v-if="item.data.state == 4">已停业</el-tag>' +
                        '<el-tag size="small" type="success" v-if="item.data.opened && item.data.shopFlag && item.data.tagId != null">{{item.data.tagName}}</el-tag>' +
                        '<span v-if="item.data.orgType != null" class="el-icon-document fr mr5" @click="showDetail($event, item.data.id)"></span>' +
                        '</span>' +
                        '</div>' +
                        '<span v-else>' +
                        '<el-radio class = "radio" :disabled = "item.data.closed || !item.data.isAllowed" v-model="checkComId" :label="item.data.id">' +
                        '<i v-if = "item.data.shopFlag" class="icon iconfont icon-mendian1 mr10 font-blue"></i>' +
                        '<i v-if = "item.data.orgType == 0" class="icon iconfont icon-icon-folder mr5 font-gray"></i>' +
                        '<i v-if = "item.data.orgType == 1 && item.data.shopFlag == false" class="icon iconfont icon-gongsi1 mr5 font-blue"></i>' +
                        '<span>{{item.data.name}}</span>' +
                        '<el-tag type="danger" v-if="item.data.state == 0">筹备中</el-tag>' +
                        '<el-tag type="danger" v-if="item.data.state == 3">计划停业</el-tag>' +
                        '<el-tag type="danger" v-if="item.data.state == 4">已停业</el-tag>' +
                        '<el-tag size="small" type="success" v-if="item.data.shopFlag && item.data.tagId != null">{{item.data.tagName}}</el-tag>' +
                        '</el-radio>' +
                        '<span v-if="item.data.orgType != null" class="el-icon-document fr mr5" @click="showDetail($event, item.data.id)"></span>' +
                        '</span>' +
                        '</span>',
                    methods: {
                        showDetail: function (event, id) {
                            event.stopPropagation();
                            //
                            openComDetailDlg(id);
                        }
                    }
                });
            },
            normalizeTreeNode: function (data) {
                Utils.forEachTreeNode(data, function (nodeData) {
                    let nodeId = nodeData['id'] || null;
                    if (nodeId == null) {
                        nodeId = Utils.genUniqueStr();
                    }
                    //
                    nodeData['nodeKey'] = nodeId;
                }, function (treeNode) {
                    let comSons = treeNode.comSons || [];
                    let departs = treeNode.departs || [];
                    let children = departs.concat(comSons);
                    //
                    treeNode.children = children;
                    return children;
                });
            },
            clickNode: function (data) {
                let isAllowed = isSysRescFrozenIsAllowed(this, data);
                if (!isAllowed) {
                    this.$message({
                        message: '当前选择的机构【' + data.name + '】该业务已冻结，请重新选择！',
                        type: 'warning',
                        offset: '200'
                    });
                    return false;
                }
                if (this.isRadio) {
                    this.checkComId = data.id;
                    this.checkComItem = data
                } else {
                    if (this.dblclickFlag) {
                        let nodeId = data.id + '';
                        //
                        let lastSelectedNodeId = this.lastSelectedNodeId;
                        let lastSelectTime = this.lastSelectTime;
                        if (!Utils.isNoB(lastSelectedNodeId) && !Utils.isNoB(lastSelectTime)) {
                            let time = new Date().getTime();
                            let t = time - lastSelectTime;
                            if (lastSelectedNodeId === nodeId && t < 500) {
                                this.notityChange(data);
                            }
                        }
                        //
                        this.lastSelectedNodeId = nodeId;
                        this.lastSelectTime = new Date().getTime();
                    } else {
                        this.notityChange(data);
                    }
                }
            },
            notityChange: function (data) {
                let resultData = {};
                resultData.id = data.id;
                resultData.merchantId = data.merchantId;
                resultData.merchantName = data.merchantName;
                resultData.bizUnitId = data.bizUnitId;
                resultData.bizUnitName = data.bizUnitName;
                resultData.name = data.name;
                resultData.level = data.level;
                resultData.parentId = data.parentId;
                resultData.comId1 = data.comId1;
                resultData.comId2 = data.comId2;
                resultData.comId3 = data.comId3;
                resultData.comId4 = data.comId4;
                resultData.shopFlag = data.shopFlag;
                resultData.closed = data.closed;
                resultData.realComId = data.realComId;
                resultData.realComCode = data.realComCode;
                resultData.realComName = data.realComName;
                //
                let closed = data.closed;
                //
                if (closed && this.closedComSelect == false) {
                    this.$message({
                        message: '当前门店已闭店，不可选中！',
                        type: 'warning',
                        offset: '200'
                    });
                    return false;
                }
                let isAllowed = isSysRescFrozenIsAllowed(this, data);
                if (!isAllowed) {
                    this.$message({
                        message: '当前选择的机构【' + data.name + '】该业务已冻结，请重新选择！',
                        type: 'warning',
                        offset: '200'
                    });
                    return false;
                }
                this.$emit('notity-change', resultData);
            },
            notityInitChange: function (data) {
                //
                let resultData = {};
                resultData.id = data.id;
                resultData.merchantId = data.merchantId;
                resultData.merchantName = data.merchantName;
                resultData.bizUnitId = data.bizUnitId;
                resultData.bizUnitName = data.bizUnitName;
                resultData.name = data.name;
                resultData.level = data.level;
                resultData.parentId = data.parentId;
                resultData.comId1 = data.comId1;
                resultData.comId2 = data.comId2;
                resultData.comId3 = data.comId3;
                resultData.comId4 = data.comId4;
                resultData.shopFlag = data.shopFlag;
                resultData.closed = data.closed;
                resultData.realComId = data.realComId;
                resultData.realComCode = data.realComCode;
                resultData.realComName = data.realComName;
                let isAllowed = isSysRescFrozenIsAllowed(this, data);
                if (!isAllowed) {
                    this.$message({
                        message: '当前选择的机构【' + data.name + '】该业务已冻结，请重新选择！',
                        type: 'warning',
                        offset: '200'
                    });
                    return false;
                }
                this.$emit('notity-init-change', resultData);
            },
            getDlgResult() {
                let self = this;
                let result = {};
                if (this.checkComId != null) {
                    let isAllowed = isSysRescFrozenIsAllowed(self, self.checkComItem);
                    if (!isAllowed) {
                        result.type = 'warn';
                        result.message = '当前选择的机构【' + self.checkComItem.name + '】该业务已冻结，请重新选择！';
                        return result;
                    }
                    result.type = 'info';
                    result.data = self.checkComItem;
                } else {
                    result.type = 'warn';
                    result.message = '请选择机构';

                }
                return result;
            },
            //组织树收缩
            showTreeCollapse: function () {
                this.treeCollapse = this.treeCollapse ? false : true;
                this.$emit('show-tree-collapse', this.treeCollapse)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/RetailerOrgTree.vue